var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('buy_form',{attrs:{"user":_vm.user,"library_link":_vm.library_link,"request_id":_vm.request_id,"charge_amount":24,"charge_amount_disabled":true,"api_prefix":_vm.api_prefix},on:{"payment_processed":_vm.payment_processed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }